module.exports = __webpack_public_path__ + "static/img/index-white.5620fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-white.png
// module id = zZvk
// module chunks = 1